import { type FC } from "react";
import { useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../../Buttons/Button";

interface Props {
    name: string;
    url: string;
}

export const ImagePreview: FC<Props> = ({ name, url }) => {
    const dispatch = useShopfrontDispatch();

    return (
        <div className="image-preview-dialog">
            <Button
                classes={[ "button-close-preview" ]}
                onClick={() => {
                    dispatch(hideDialog());
                }}
            >
                <FontAwesomeLight icon="times" />Close
            </Button>
            <img
                src={url}
                alt={name}
            />
        </div>
    );
};
